import { MdDocumentScanner } from 'react-icons/md'
import { useNavigate, useParams } from 'react-router'
import FIconWrapper from '../../../components/FIconWrapper'
import FButton from '../../../components/FButton'

const DocumentBtn = () => {
    const fileId = useParams().id
    const navigate = useNavigate();
    const handleButtonClick = () =>
        navigate(`/file/${fileId}/document`)

    return (
        <FButton onClick={handleButtonClick}>
            <FIconWrapper>
                <MdDocumentScanner size={20} />
                Documents
            </FIconWrapper>
        </FButton>
    )
}
export default DocumentBtn
